import { useSignal } from "@preact/signals-react";
import { PreviewAppUtil } from "@uiview/views/PreviewApp/PreviewAppUtil";
import { useCallback, useRef } from "react";
import useState from "react-usestateref";

export type CheckedUIListType = {
  label: "SaaS" | "SaaS V2" | "Thinking App" | "Web Application" | "AI App" | "Static Website";
  value: "saas" | "saasV2" | "thinkingApp";
  checked?: boolean;
  isStaticApp?: boolean;
};
export type SendToAppStagingData = {
  cb?: () => void;
  outputCb?: () => void;
};

export type BtnType = { id: string; index: number };

const deprecatedDisplayThought = {
  displayThought: {
    get() {
      console.warn("displayThought has been deprecated! use sassUIData.output");
    },
  },
  setDisplayThought(value: any) {
    console.warn("SetDisplayThrough has been deprecated! use setSaasUIData output");
  },
};

/**
 * saasUI， saasV2, thinkAPP (从 homeUsePlugin 抽离)
 * @returns
 */
export default function useSaasAndThinkAppState() {
  // saas previews state
  // const saasPreviewIndexRef = useRef(0);

  const sendToAppStagingData = useSignal<SendToAppStagingData>({});
  const [saasUIData, setSaasUIData, saasUIDataRef] = useState(PreviewAppUtil.genDefaultUISaasValue());

  // const thinkingAppPreviewIndexRef = useRef(0);
  // const saasV2PreviewIndexRef = useRef(0);
  const thinkingAppPreviewIndexRef = PreviewAppUtil.thinkingAppPreviewIndexRef;
  const saasPreviewIndexRef = PreviewAppUtil.saasPreviewIndexRef;
  const saasV2PreviewIndexRef = PreviewAppUtil.saasV2PreviewIndexRef;

  //  创建project时标记一次，创建时赋值true，执行特定方法后重置为false
  const firstCreateProjectRef = useRef(false);
  //  第一次运行边，运行后赋值为true
  const firstRunEdgeRef = useRef(false);
  const [checkedUIList, setCheckedUIList] = useState<CheckedUIListType[]>([]);
  const [saasV2UIData, setSaasV2UIData, saasV2UIDataRef] = useState({
    appName: "",
    appTitle: "",
    appUseCase1: "",
    appUseCase2: "",
    appUseCase3: "",
    newPreviewCase: "",
    appTagline: "",
    inputSuggestion: "",
    placeholder: "Enter something",
    input: [],
    output: [],
  });
  const [thinkingAppUIData, setThinkingAppUIData, thinkingAppUIDataRef] = useState({
    title: "",
    subTitle: "",
    input: [],
    output: [],
  });

  const UIConfigRef = useRef({
    thinkingApp: {
      UIData: thinkingAppUIDataRef,
      previewIndexRef: thinkingAppPreviewIndexRef,
      setUIDataFunc: setThinkingAppUIData,
    },
    saas: {
      UIData: saasUIDataRef,
      previewIndexRef: saasPreviewIndexRef,
      setUIDataFunc: setSaasUIData,
    },
    saasV2: {
      UIData: saasV2UIDataRef,
      previewIndexRef: saasV2PreviewIndexRef,
      setUIDataFunc: setSaasV2UIData,
    },
  });

  //  aisaas中是否触发了 Add Content
  const [isClickAddToContent, setIsClickAddToContent, isClickAddToContentRef] = useState(false);
  //  是否添加input node
  const [isAddInputNode, setIsAddInputNode] = useState(false);
  //  是否添加output node
  const [isAddOutputNode, setIsAddOutputNode] = useState(false);
  const [addContentId, setAddContentId, addContentIdRef] = useState("");
  const [nextAddContentId, setNextAddContentId] = useState("");

  return {
    thinkingAppPreviewIndexRef,
    saasPreviewIndexRef,
    saasV2PreviewIndexRef,
    firstCreateProjectRef,
    firstRunEdgeRef,

    saasUIData,
    setSaasUIData,
    saasUIDataRef,
    saasV2UIData,
    setSaasV2UIData,
    saasV2UIDataRef,
    thinkingAppUIData,
    setThinkingAppUIData,
    thinkingAppUIDataRef,
    UIConfigRef,

    ...deprecatedDisplayThought,
    checkedUIList,
    setCheckedUIList,

    isClickAddToContent,
    isClickAddToContentRef,
    sendToAppStagingData,
    setIsClickAddToContent,
    isAddInputNode,
    setIsAddInputNode,
    isAddOutputNode,
    setIsAddOutputNode,
    addContentId,
    addContentIdRef,
    setAddContentId,
    nextAddContentId,
    setNextAddContentId,
  };
}
